

























































import { Component, Mixins, Prop, Inject, Vue } from "vue-property-decorator";
import { INotificationHook } from "@/models/notifications";
import { AdminRoutes } from "@/data/enums/router";

import {
  ITemplatesProviderData,
  ITemplatesProviderMethods
} from "@/models/providers/templates";

@Component({
  components: {
    "actions-table-row": () =>
      import("@/components/app/admin/automation/actionTableRow.vue")
  }
})
export default class TemplatesTableView extends Mixins(Vue) {
  // Inject
  @Inject({ from: "templatesProvider" })
  public templatesProvider!: () => ITemplatesProviderData;

  @Inject({ from: "templatesProviderMethods" })
  public $templatesMethods!: ITemplatesProviderMethods;

  // Props
  @Prop({ default: false })
  public showCategory!: boolean;

  @Prop({ default: null })
  public hookId!: INotificationHook["id"];

  // Computed

  public get $templatesData() {
    return this.templatesProvider();
  }

  public get table() {
    return this.$templatesData.table;
  }

  // Methods

  public getTemplateToRoute(template) {
    return {
      name: this.$route.path.includes("email-templates")
        ? AdminRoutes.EMAIL_TEMPLATE_EDIT
        : "adminAutomationAction",
      params: {
        templateId: template.id
      }
    };
  }

  public viewAllActionsForHook(hookId: string) {
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import("@/components/app/admin/automation/triggerModal.vue"),
        props: { hookId },
        width: 540,
        events: {
          "actions-updated": () => this.$templatesMethods.reloadData()
        }
      }
    });
  }
}
